var map = {
	"./medical_1_1.png": "5651",
	"./medical_1_2.png": "95f8",
	"./medical_1_3.png": "b7cb",
	"./medical_2_1.png": "c566",
	"./medical_2_2.png": "50de",
	"./medical_2_3.png": "d22a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2887";